import React from 'react';
import { ExternalLink, BadgeCheck } from 'lucide-react';
import { TrustpilotStars } from './StarRating';

const CompanyHeader = ({ company, onWriteReview }) => {
  if (!company) return null;

  return (
    <div className="bg-white border-b">
      <div className="max-w-7xl mx-auto px-4 py-6">
        {/* Visit Website Link */}
        <a
          href={company.website}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-1 text-sm text-[#1a1a1a] hover:underline mb-4"
        >
          Visiter le site web
          <ExternalLink className="w-3.5 h-3.5" />
        </a>

        {/* Claimed Profile Badge */}
        {company.profile_claimed && (
          <div className="flex items-center gap-1.5 text-sm text-gray-600 mb-4">
            <BadgeCheck className="w-4 h-4 text-blue-500" />
            <span>Profil revendiqué</span>
          </div>
        )}

        {/* Company Name and Rating */}
        <div className="flex flex-col md:flex-row md:items-start gap-4 md:gap-8">
          <div className="flex-1">
            <div className="flex items-center gap-3 mb-2">
              <h1 className="text-3xl font-bold text-[#1a1a1a]">{company.name}</h1>
              <span className="text-gray-500">Avis</span>
              <span className="text-gray-900 font-semibold">{company.stats?.total_reviews || 0}</span>
            </div>

            {/* Trust Score */}
            <div className="flex items-center gap-3 mb-4">
              <TrustpilotStars rating={company.stats?.trust_score || 0} size="lg" />
              <span className="text-2xl font-bold text-[#1a1a1a]">{company.stats?.trust_score || 0}</span>
            </div>

            {/* Category */}
            <a
              href="#"
              className="text-sm text-[#1a1a1a] hover:underline"
            >
              {company.category}
            </a>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-3">
            <button
              onClick={onWriteReview}
              className="inline-flex items-center justify-center px-6 py-3 bg-[#1a1a1a] text-white font-medium rounded hover:bg-[#333] transition-colors"
              data-testid="write-review-btn"
            >
              Écrire un avis
            </button>
            <a
              href={company.website}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 px-6 py-3 border border-[#1a1a1a] text-[#1a1a1a] font-medium rounded hover:bg-gray-50 transition-colors"
            >
              Visiter le site web
              <ExternalLink className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyHeader;
